export default "/img/JO.48b91262d6c68d8ddee689d7646774f3.png";